<template>
    <div class="search-all">
        <p class="search-count">找到{{total_count}}条搜索结果</p>
        <product></product>
        <support></support>
    </div>
</template>
<script>
    import product from './Common/ProductItem.vue'
    import support from './Common/SupportItem.vue'
    import Signature from '../../lib/Signature'

    export default {
        data () {
            return {
                total_count: ''
            }
        },
        components: {
            product, support
        },
        methods: {
            fetchData () {
                let data = {}
                const module = 'index/search/search'
                data.sub_time = Signature.timestamp()
                data.user_id = this.Local.getUserId()
                data.content = this.$route.query.q
                data.token = this.Local.getUserToken()
                data.sign = Signature.create(module, data.sub_time)
                data.lang = this.$i18n.locale
                this.$http.get(process.env.BASEURL + module, {
                    params: data
                })

                .then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        console.log(resp.data)
                        this.total_count = resp.data.data.count
                    }
                }.bind(this))
            }
        },
        watch: {
            '$route': function (to, from) {
                this.fetchData()
            }
        },
        created () {
            this.fetchData()
        }
    }
</script>
<style scoped lang="scss">
    .search-count {
        font-size: 14px;
        color: #99A9BF;
        margin-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// All.vue?4b077bcb